import { MODULE } from "./select-template.actionTypes";

export const isCreatingTemplateStatus = (state) =>
  state.getIn([MODULE, "isCreatingTemplateStatus"]);
